import { connect } from "react-redux";

import App from "../components";
import { ApplicationState } from "../../store/ApplicationState";

const mapStateToProps = ({userModuleState}: ApplicationState) => ({
    moduleData: userModuleState
});


const mapDispatchToProps = (
) => {
    return {
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);